import React from 'react';
import { Field, useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { FiltersOptionsWrapper } from '../styled';
import {
  LabelText,
  LeasedTab,
  LeasedTabLabel,
  optionWrapperStyles
} from './styled';

const leasedType = [
  { value: 'false', name: 'new_search.buy', id: 'new-search-form-buy' },
  { value: 'true', name: 'new_search.rent', id: 'new-search-form-rent' }
];

interface NewSearchLeasedFiltersProps {
  value: string;
}

export const NewSearchLeasedFilters = ({
  value
}: NewSearchLeasedFiltersProps) => {
  const { t } = useTranslation();
  const { change } = useForm();
  const mapList = leasedType;

  const onChange = (newType: string) => {
    change('leased', newType);
  };

  return (
    <FiltersOptionsWrapper styles={optionWrapperStyles}>
      {mapList.map(type => (
        <LeasedTab
          tabIndex={0}
          key={type.id}
          role="button"
          data-stat={type.id}
          onClick={() => onChange(type.value)}
          onKeyPress={() => onChange(type.value)}
        >
          <LeasedTabLabel isActive={value === type.value}>
            <Field
              type="radio"
              component="input"
              value={type.value}
              className="display-none"
              name="leased"
            />
            <LabelText tab="body_2" $isActive={value === type.value}>
              {t(type.name)}
            </LabelText>
          </LeasedTabLabel>
        </LeasedTab>
      ))}
    </FiltersOptionsWrapper>
  );
};
